export default {
  search: "搜索",
  apply_booklet: "会刊申请",
  apply: "新增申请",
  applied_booklet: "已申请会刊信息",
  booklet_config: "此处显示会刊备注",
  boothNo: "展位号",

  company_name: "公司名称",
  en_company_name: "公司英文名称",
  contactPerson: "联系人",
  phone: "联系电话",
  email: "电子邮箱",
  address: "中文地址",
  englishAddress: "英文地址",
  apply_date: "申请时间",
  action: "操作",
  modify_booklet: "修改",
  cn_company_name: "公司中文名",
  form_title: "填写会刊信息",
  form_postCode: "邮编",
  form_remarks: "备注",
  form_en_remarks: "英文备注",
  form_tips:
    "如果查询不到展位号或者展商信息与展商信息不符，请务必与工作人员确认。",
  form_save: "保存",
  form_cancel: "取消",
  form_boothNo_check: "请输入展位号",
  form_boothNo_check_new: "展位号可能含有特殊符号：下划线（_）或中划线（-），请输入完整的展位号",
  "保险码校验信息": "请输入保险码",
  form_cn_company_name_check: "请输入公司中文名",
  form_en_company_name_placeholder: "请输入公司英文名",
  form_address_placeholder: "请输入地址",
  form_en_address_placeholder: "请输入英文地址",
  form_contactPerson_check: "请输入联系人",
  form_phone_placeholder: "请输入联系电话",
  form_phone_check: "请输入正确的手机号码",
  form_email_placeholder: "请输入电子邮箱",
  form_email_check: "请输入正确的电子邮箱",
  form_postCode_placeholder: "请输入邮编",
  form_remarks_placeholder: "请输入备注",
  form_en_remarks_placeholder: "请输入英文备注",
  loding: "加载中...",
  action_success: "操作成功！",
  request_error: "请求数据失败！",
  会刊申请截止提醒: "会刊申请截止提醒",
  会刊申请截止时间: "已到会刊申请截止时间，不可以再申请了"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/booklet.js